import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { externalLaunchState, externalLaunchStateDefault } from './state';

const STALE_THRESHOLD_MS = 24 * 60 * 60 * 1000;

export const useExternalLaunchLifecycle = (currentCaseSmid: Nullable<string>) => {
  const [state, setState] = useRecoilState(externalLaunchState);

  useEffect(() => {
    if (!state.isExternalLaunch) return;

    const isStale = state.launchedAt && Date.now() - state.launchedAt > STALE_THRESHOLD_MS;
    const isCaseChanged =
      currentCaseSmid && state.launchedCaseSmid && currentCaseSmid !== state.launchedCaseSmid;

    if (isStale || isCaseChanged) {
      setState(externalLaunchStateDefault);
    }
  }, [currentCaseSmid, state, setState]);
};
